// extracted by mini-css-extract-plugin
export var dogimage = "SectionSearchSite-module--dogimage--d8ca2";
export var search = "SectionSearchSite-module--search--05ba2";
export var searchinput = "SectionSearchSite-module--searchinput--deef8";
export var searchinputwrapper = "SectionSearchSite-module--searchinputwrapper--e3add";
export var sitesearchinner = "SectionSearchSite-module--sitesearchinner--8918b";
export var title = "SectionSearchSite-module--title--d7640 headings-module--sectionHeading--a8f67";